import Gavel from '@mui/icons-material/Gavel';
import { Button, Dialog, DialogActions, DialogTitle, Tooltip, Typography } from '@mui/material';
import { action, computed, makeObservable, observable, reaction } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Fragment } from 'react';
import Configuracao from '../../util/Configuracao';
import NumeroProcesso from '../NumeroProcesso';
import PainelFiltros from '../PainelFiltros';
import ReactComponent from '../ReactComponent';
import FiltroRapido from './FiltroRapido';
import OperacoesEmLoteSelecionar from './OperacoesEmLoteSelecionar';
import PainelJulgamento from './PainelJulgamento';
import PainelProcessosOperacoesEmLote from './PainelProcessosOperacoesEmLote';
import CancelIcon from '@mui/icons-material/Cancel';

class ApreciarLote extends ReactComponent {
    dialogOpen = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            dialogOpen: observable,
            handleClickIcone: action,
            handleCloseDialog: action,
            processos: computed,
            processosSelecionados: computed,
            quantidadeProcessosVistaMesa: computed,
            quantidadeProcessosRetornoVistaRegimetal: computed,
            limparProcessoPesquisa: action,
            mensagemLoteSemProcessos: computed,
            renderConteudoDialog: computed
        });

        this.createReaction(
            reaction(
                () => this.dialogOpen,
                () => this.limparProcessoPesquisa()
            )
        );
    }

    handleClickIcone = () => {
        this.dialogOpen = true;
    };

    handleCloseDialog = () => {
        this.dialogOpen = false;
    };

    get processos() {
        return (this.salaSessaoStore.processosPendentesFiltrados || []).filter((registro) =>
            this.filtrarProcessoPeloNumero(registro)
        );
    }

    get processosSelecionados() {
        return this.processosSelecionaveis.filter((registro) => this.store.isCheckedOperacoesEmLote(registro));
    }

    get processosSelecionaveis() {
        return this.processos.filter(
            (registro) =>
                !registro.necessitaImportacaoSalaSessao && this.salaSessaoStore.isPermitidaApreciacaoProcesso(registro)
        );
    }

    get quantidadeProcessosVistaMesa() {
        return this.processosSelecionados.filter(
            (processo) => processo.informacaoProcessoSalaSessao.magistradoVistaEmMesa
        ).length;
    }

    get quantidadeProcessosRetornoVistaRegimetal() {
        return this.processosSelecionados.filter((processo) => processo.informacoesAdicionais.RetornoVistaRegimental)
            .length;
    }

    limparProcessoPesquisa = () => {
        this.processoPesquisa = { numero: '', digito: '', ano: '', orgao: '', regional: '', vara: '' };
    };

    get mensagemLoteSemProcessos() {
        return 'Não há processos pendentes na sessão' + this.complementoMensagemFiltrando;
    }

    getAlertasProcesso = (registro) => {
        let alertas = [];

        if (registro.necessitaImportacaoSalaSessao) {
            alertas.push({ mensagem: 'Processo não importado para sala de sessão', impeditivo: true });
        }

        if (
            registro.processo.origem === Configuracao.ORIGEM_PJE &&
            this.sessaoStore.sessaoSelecionada.situacoes[registro.sessaoId] !== Configuracao.STATUS_INICIADA &&
            this.sessaoStore.sessaoSelecionada.situacoes[registro.sessaoId] !== Configuracao.STATUS_PLENARIO_VIRTUAL
        ) {
            alertas.push({
                mensagem: 'Apenas sessões com status "INICIADA" ou "PLENÁRIO VIRTUAL" permitem apreciação de processos',
                impeditivo: true
            });
        }

        return alertas;
    };

    render() {
        if (!this.isComponenteHabilitado('ApreciarLote')) {
            return null;
        }
        return (
            <div>
                <div
                    style={{ marginRight: '10px' }}
                    className="corBotao"
                >
                    <Tooltip
                        title={<Typography>Apreciar processos em lote</Typography>}
                        placement="top-start"
                    >
                        <Gavel
                            onClick={this.handleClickIcone}
                            style={{ cursor: 'pointer', width: '24px', height: '24px' }}
                        />
                    </Tooltip>
                </div>
                {this.dialogOpen && (
                    <Dialog
                        fullWidth
                        maxWidth="xl"
                        onClose={this.handleCloseDialog}
                        open={this.dialogOpen}
                        PaperProps={{ style: { height: '100%' } }}
                    >
                        <DialogTitle
                            id="simple-dialog-title"
                            style={{ padding: '16px 24px 0px' }}
                        >
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        flexWrap: 'wrap',
                                        flexGrow: 1
                                    }}
                                >
                                    <h4 style={{ margin: '0px' }}>Apreciar lote de processos</h4>
                                    <div style={{ margin: '0px 10px' }}>
                                        <NumeroProcesso
                                            dense
                                            tooltip="Número do processo a ser pesquisado na listagem"
                                            callbackOnChange={this.callbackNumeroProcesso}
                                            clickLimpar={this.limparProcessoPesquisa}
                                        />
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <PainelJulgamento loteProcessos={this.processosSelecionados} />
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                margin: '10px',
                                                paddingTop: '5px'
                                            }}
                                        >
                                            <PainelFiltros />
                                        </div>
                                        <FiltroRapido id="filtroRapidoApreciarLote" />
                                    </div>
                                </div>
                            </div>
                            <div>
                                <h5 style={{ margin: '0px' }}>
                                    {this.quantidadeProcessosVistaMesa > 0 && (
                                        <Typography>
                                            * CUIDADO! Há {this.quantidadeProcessosVistaMesa} processo(s) com{' '}
                                            <span style={{ fontWeight: 'bold', color: 'red' }}>vista em mesa</span>{' '}
                                            selecionado(s)
                                        </Typography>
                                    )}
                                    {this.quantidadeProcessosRetornoVistaRegimetal > 0 && (
                                        <Typography>
                                            * CUIDADO! Há {this.quantidadeProcessosRetornoVistaRegimetal} processo(s)
                                            com{' '}
                                            <span style={{ fontWeight: 'bold', color: 'red' }}>
                                                retorno de vista regimental
                                            </span>{' '}
                                            selecionado(s)
                                        </Typography>
                                    )}
                                </h5>
                            </div>
                        </DialogTitle>
                        {this.renderConteudoDialog}
                        <DialogActions>
                            <Button
                                onClick={this.handleCloseDialog}
                                color="secondary"
                                variant="outlined"
                                endIcon={<CancelIcon />}
                            >
                                Fechar
                            </Button>
                        </DialogActions>
                    </Dialog>
                )}
            </div>
        );
    }

    get renderConteudoDialog() {
        return (
            <Fragment>
                <OperacoesEmLoteSelecionar
                    processosSelecionaveis={this.processosSelecionaveis}
                    processos={this.processos}
                />
                <PainelProcessosOperacoesEmLote
                    processos={this.processos}
                    mensagemLoteSemProcessos={this.mensagemLoteSemProcessos}
                    alertasProcessos={this.alertasProcessos}
                />
            </Fragment>
        );
    }
}

export default inject('stores')(observer(ApreciarLote));
